import type {
  AdminLoginIn,
  AdminLoginOut,
  AdminMeOut,
  AdminMePatchIn,
  NavItemOut,
  TokensOut,
} from '@/shared/api';

/*
 * Модели auth/me админки — из сгенерированного контракта (ARCH-07a, ТЗ ACC 4.8.3);
 * здесь только доменные имена для слайса сессии.
 */

/** Роли админки (TeamMember.role, ТЗ 4.2.2) — enum контракта `TeamRole`. */
export { TeamRole as MemberRole } from '@/shared/api';

export type Me = AdminMeOut;
/** Пункт меню из GET /admin/me: `nav: [{group_key, group, key, label}]` (ТЗ 4.2.2.1, 4.8.3). */
export type NavItem = NavItemOut;
export type AuthTokens = TokensOut;
export type LoginRequest = AdminLoginIn;
export type LoginResponse = AdminLoginOut;
/** PATCH /admin/me `{admin_locale?, phone?}`: отсутствующее поле не меняется, `phone: null` очищает. */
export type UpdateMeRequest = AdminMePatchIn;

/**
 * Коды ошибок входа (описание `POST /admin/auth/login` в контракте, ТЗ 4.8.1). Коды модулей в
 * контракте — строки `ErrorBody.code`, а не enum, поэтому набор известных клиенту кодов задан здесь.
 */
export const AuthErrorCode = {
  InvalidCredentials: 'invalid_credentials',
  AccountBlocked: 'account_blocked',
  Forbidden: 'forbidden',
  RateLimited: 'rate_limited',
} as const;
export type AuthErrorCode = (typeof AuthErrorCode)[keyof typeof AuthErrorCode];
